import { getField, updateField } from "vuex-map-fields";
import Repository from "@/repository";

const inspection_API = "/inspection";

// ----------------------- STATE ------------------------- //
const state = {
  inspection_data: [],
  currentIndex: -1
};

// ----------------------- GETTERS ----------------------- //
const getters = {
  getinspection: state => getField(state.inspection_data[state.currentIndex]),

  getCurrentinspection: state => {
    return state.inspection_data[state.currentIndex];
  }
};

// ----------------------- MUTATIONS -------------------- //
const mutations = {
  updateinspection(state, payload) {
    updateField(state.inspection_data[state.currentIndex], payload);
  },

  setCurrentIndexByID(state, theID) {
    state.currentIndex = state.inspection_data.findIndex(
      inspection => inspection.id == theID
    );
  },

  loadAllinspections(state, payload) {
    state.inspection_data = payload.data;
    state.currentIndex = 0;
  },

  addinspection(state, payload) {
    state.inspection_data.push(payload.data);
    state.currentIndex = state.inspection_data.length - 1;
  },

  saveinspection(state, payload) {
    state.inspection_data[state.currentIndex] = payload.data;
  },

  fetchinspection(state, payload) {
    if (state.currentIndex == -1) {
      state.inspection_data.push(payload.data);
      state.currentIndex = 0;
    } else {
      state.inspection_data[state.currentIndex] = payload.data;
    }
  },

  deleteinspection(state, payload) {
    state.currentIndex = state.inspection_data.findIndex(
      inspection => inspection.id == payload.data.id
    );
    state.inspection_data.splice(state.currentIndex, 1);
  },
  reset(state) {
    state.inspection_data = []
    state.currentIndex = -1
  }
};

// ----------------------- ACTIONS -------------------- //
const actions = {
  async loadAllinspections({ commit }) {
    try {
      commit("loadAllinspections", await Repository.get(`${inspection_API}`));
    } catch (error) {
      console.log(error);
    }
  },

  async addinspection({ commit }) {
    await Repository.get(`${inspection_API}/new`)
      .then(response => {
        commit("addinspection", response);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async saveinspection({ state, commit }) {
    try {
      commit(
        "saveinspection",
        await Repository.post(
          `${inspection_API}`,
          state.inspection_data[state.currentIndex]
        )
      );
    } catch (error) {
      console.log(error);
    }
  },

  async fetchinspection({ commit }, payloadID) {
    try {
      commit(
        "fetchinspection",
        await Repository.get(`${inspection_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async deleteinspection({ commit }, payloadID) {
    try {
      commit(
        "deleteinspection",
        await Repository.delete(`${inspection_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async searchinspections({ commit }, searchTerm) {
    try {
      commit(
        "loadAllinspections",
        await Repository.get(`${inspection_API}/search?q=${searchTerm}`)
      );
    } catch (error) {
      console.log(error);
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
